exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preselected-appointment-type {\n  font-size: 1.2rem; }\n\n.preselected-appointment-type {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 0.75rem;\n  height: 3.2rem;\n  padding: 0 1rem;\n  background-color: white;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  margin-bottom: 0.5rem; }\n\n.preselected-appointment-type span {\n    display: block;\n    border-left: 1px solid lightgray;\n    padding: 0.15rem 0 0 0.75rem;\n    line-height: 1.15; }\n\n.preselected-appointment-type span.small-screen {\n      display: none; }\n\n@media screen and (max-width: 768px) {\n        .preselected-appointment-type span.small-screen {\n          display: block; } }\n\n@media screen and (max-width: 768px) {\n      .preselected-appointment-type span:not(.small-screen) {\n        display: none; } }\n\n.doctor-list {\n  margin-top: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/src/app/step-one/step-one.component.scss
// module id = ../../../../../src/app/step-one/step-one.component.scss
// module chunks = main